import VideoJS from 'video.js';
import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { find } from 'lodash';
import 'fuckadblock';

import * as ActionCreators from '../../actions/ActionCreators';
import * as ActionTypes from '../../actions/ActionTypes';
import * as Controls from '../../ui/UIControlsNames';
import * as VideoTypes from '../../player/videoSource/videoTypes';


export const blockedStreamError = (action$, __, { }) => action$
    .ofType(ActionTypes.HLS_EVENT_LOAD_ERROR)
    .pluck('payload', 'networkDetails')
    .filter(networkDetails => !!networkDetails)
    .pluck('status')
    .filter(status => status === 0)
    .take(1)
    .switchMap(() => Observable.of(
        ActionCreators.setStreamBlocked(true),
        ActionCreators.retryPlainStream(),
    ));


// if fuckAdBlock sees that there's an adblocker on, set streamBlocked
export const setStreamBlockedEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.INIT)
    .map(() => store.getState())
    .filter(state => state.player.adsEnabled)
    .do(() => {
        fuckAdBlock = new FuckAdBlock({
            checkOnLoad: true
        });
        fuckAdBlock.onDetected(() => player.trigger('streamBlocked', {}))
    })
    .ignoreElements();


export const retryPlainStreamEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.RETRY_PLAIN_STREAM)
    .map(() => store.getState())
    .filter(state => (state.player.streamBlocked))
    .map(state => ActionCreators.setPlaybackURL(`${state.videoSource.contentURL}?hdnts=${state.cdnToken.token}`));


export const setAuditudeAdPlaying = (action$, store, { }) => action$
    .ofType(ActionTypes.HLS_FRAG_CHANGED)
    .map(() => store.getState().auditude.adMarkers)
    .filter(adMarkers => !!adMarkers.length)
    .map(adMarkers => find(adMarkers, (adMarker) => adMarker.type === 'AdBegin'))
    .filter(ad => !!ad)
    .map(ad => ActionCreators.setCurrentAd(ad));


export const setAuditudeAdPodBegin = (action$, store, { }) => action$
    .ofType(ActionTypes.HLS_FRAG_CHANGED)
    .map(() => store.getState().auditude.adMarkers)
    .filter(adMarkers => !!adMarkers.length)
    .map(adMarkers => find(adMarkers, (adMarker) => adMarker.type === 'PodBegin'))
    .filter(adPod => !!adPod)
    .map(adPod => ActionCreators.setCurrentAdPod(adPod))


export const setAuditudeAdPodEnded = (action$, store, { }) => action$
    .ofType(ActionTypes.HLS_FRAG_CHANGED)
    .map(() => store.getState().auditude.adMarkers)
    .filter(adMarkers => !!adMarkers.length)
    .map(adMarkers => find(adMarkers, (adMarker) => adMarker.type === 'PodEnd'))
    .filter(ad => !!ad)
    .switchMap(ad => Observable.of(ad)
        .delay((ad.offset * 1000) || 0)
        .switchMap(() => Observable.of(
            ActionCreators.clearCurrentAd(),
            ActionCreators.clearCurrentAdPod(),
        )));


// if ad has a clickthrough url, set up click handler
export const setAdClickHandler = (action$, store, { player, auditude }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .pluck('payload')
    .map(ad => ad.clickThroughURL)
    .filter(Boolean)
    .switchMap(clickThroughURL => {
        const modal$ = Observable.create(() => {
            const clickHandler = auditude.onAdClick.bind(null, clickThroughURL, player);
            const AdClickOverlay = VideoJS.getComponent(Controls.AD_CLICK_OVERLAY);
            const content = new AdClickOverlay(clickHandler);
            const modal = player.createModal(content.el(), {
                label: 'Ad Clickthrough',
                pauseOnOpen: false
            });

            modal.addClass('as-ad-click-modal-dialog');

            return () => {
                if (modal.opened()) modal.close();
                content.dispose();
            }
        });

        return modal$
            .takeUntil(action$.ofType(ActionTypes.CLEAR_CURRENT_AD_POD))
            .ignoreElements();
    });


export const setAdEndTimeEpic = (action$, __, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD_POD)
    .pluck('payload')
    .map(adPod => ActionCreators.setAdEndTime(player.currentTime() + adPod.breakdur))


export const setCurrentAdEndTimeEpic = (action$, __, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .pluck('payload')
    .map(ad => ActionCreators.setCurrentAdEndTime(player.currentTime() + ad.duration))


export const setAdTimeRemainingEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE)
    .map(() => store.getState().auditude)
    .filter(auditude => !!auditude.currentAdPod && auditude.adEndTime !== null)
    .map(auditude => ActionCreators.setAdTimeRemaining(auditude.adEndTime - player.currentTime()));


export const setCurrentAdTimeRemainingEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE)
    .map(() => store.getState().auditude)
    .filter(auditude => !!auditude.currentAd && auditude.currentAdEndTime !== null)
    .map(auditude => ActionCreators.setCurrentAdTimeRemaining(auditude.currentAdEndTime - player.currentTime()));


export const adCountdownSetEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD_POD)
    .map(() => store.getState().auditude.adTimeRemaining)
    .do(adTimeRemaining => {
        const adCountdown = player.getChild(Controls.AD_COUNTDOWN) || player.addChild(Controls.AD_COUNTDOWN);
        adCountdown.timeRemaining(adTimeRemaining);
    })
    .ignoreElements();


export const adCountdownUpdateEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_AD_TIME_REMAINING)
    .map(() => store.getState().auditude)
    .do(auditude => {
        const adCountdown = player.getChild(Controls.AD_COUNTDOWN) || player.addChild(Controls.AD_COUNTDOWN);
        adCountdown.timeRemaining(auditude.adTimeRemaining);
    })
    .ignoreElements();


export const adCountdownClearEpic = (action$, __, { player }) => action$
    .ofType(ActionTypes.CLEAR_CURRENT_AD)
    .do(() => player.removeChild(Controls.AD_COUNTDOWN))
    .ignoreElements();


export const trackBreakStart = (action$, store, { }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD_POD)
    .map(() => store.getState().auditude.trackingCallBreakStart)
    .switchMap(trackingCallBreakStart => Observable.fromPromise(
        fetch(`${trackingCallBreakStart}`).catch(() => Observable.empty())
    ))
    .ignoreElements();


export const trackBreakEnd = (action$, store, { }) => action$
    .ofType(ActionTypes.HLS_FRAG_CHANGED)
    .map(() => store.getState().auditude.adMarkers)
    .filter(adMarkers => !!adMarkers.length)
    .map(adMarkers => find(adMarkers, (adMarker) => adMarker.type === 'PodEnd'))
    .filter(ad => !!ad)
    .map(() => store.getState().auditude.trackingCallBreakEnd)
    .switchMap(trackingCallBreakEnd => Observable.fromPromise(
        fetch(`${trackingCallBreakEnd}`).catch(() => Observable.empty())
    ))
    .ignoreElements();


export const trackFirstQuartileEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .switchMap(() => action$
        .ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING)
        .map(() => {
            const auditude = store.getState().auditude
            const currentAdDuration = auditude.currentAd.duration;
            const currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        })
        .first(remaining => ((remaining) < 0.75))
        .map(() => store.getState().auditude.trackingCallFirstQuartile)
        .switchMap(trackingCallFirstQuartile => Observable.fromPromise(
            fetch(`${trackingCallFirstQuartile}`)).catch(() => Observable.empty())
        ))
    .ignoreElements();


export const trackMidpointEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .switchMap(() => action$
        .ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING)
        .map(() => {
            const auditude = store.getState().auditude
            const currentAdDuration = auditude.currentAd.duration;
            const currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        })
        .first(remaining => ((remaining) < 0.5))
        .map(() => store.getState().auditude.trackingCallMidpoint)
        .switchMap(trackingCallMidpoint => Observable.fromPromise(
            fetch(`${trackingCallMidpoint}`)).catch(() => Observable.empty())
        ))
    .ignoreElements();


export const trackThirdQuartileEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .switchMap(() => action$
        .ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING)
        .map(() => {
            const auditude = store.getState().auditude
            const currentAdDuration = auditude.currentAd.duration;
            const currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        })
        .first(remaining => ((remaining) < 0.25))
        .map(() => store.getState().auditude.trackingCallThirdQuartile)
        .switchMap(trackingCallThirdQuartile => Observable.fromPromise(
            fetch(`${trackingCallThirdQuartile}`)).catch(() => Observable.empty())
        ))
    .ignoreElements();


export const trackCompleteEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.SET_CURRENT_AD)
    .switchMap(() => action$
        .ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING)
        .map(() => {
            const auditude = store.getState().auditude
            const currentAdDuration = auditude.currentAd.duration;
            const currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        })
        .first(remaining => ((remaining) < 0.05))
        .map(() => store.getState().auditude.trackingCallComplete)
        .switchMap(trackingCallComplete => Observable.fromPromise(
            fetch(`${trackingCallComplete}`)).catch(() => Observable.empty())
        ))
    .ignoreElements();


export default combineEpics(
    blockedStreamError,
    retryPlainStreamEpic,
    setStreamBlockedEpic,
    setAuditudeAdPlaying,
    setAuditudeAdPodBegin,
    setAuditudeAdPodEnded,
    setAdEndTimeEpic,
    setCurrentAdEndTimeEpic,
    setAdTimeRemainingEpic,
    setCurrentAdTimeRemainingEpic,
    setAdClickHandler,
    adCountdownSetEpic,
    adCountdownUpdateEpic,
    adCountdownClearEpic,
    trackBreakStart,
    trackBreakEnd,
    trackFirstQuartileEpic,
    trackMidpointEpic,
    trackThirdQuartileEpic,
    trackCompleteEpic,
);



// WEBPACK FOOTER //
// ./src/ads/auditude/epics.js